module.exports = __webpack_public_path__ + "img/3.940124ae.png";